'use strict';
const _ = require('lodash');
const Enum = require('./enum');
const { LockActions } = require('./locks');

// constants for window actuator system（WA）

/**
 * Defines wa group types
 *
 * @enum
 * @readonly
 */
exports.WaGroupTypes = Object.create(Enum, {
  ACTUATOR: { value: 'actuator', enumerable: true },
});

/**
 * Defines wa group operation types
 *
 * @enum
 * @readonly
 */
exports.WaGroupOpTypes = Object.create(Enum, {
  CREATE: { value: 'create', enumerable: true },
  LINK: { value: 'link', enumerable: true },
  SYNC: { value: 'sync', enumerable: true },
  UPDATE: { value: 'update', enumerable: true },
  DELETE: { value: 'delete', enumerable: true },
});

/**
 * Defines wa group origin
 *
 * @enum
 * @readonly
 */
exports.WaGroupOrigin = Object.create(Enum, {
  APP: { value: 'app', enumerable: true },
  REMOTE: { value: 'remote', enumerable: true },
});

/**
 * Defines wa group operation states
 *
 * @enum
 * @readonly
 */
exports.WaGroupOpStates = Object.create(Enum, {
  UPDATING: { value: 'updating', enumerable: true },
  UPDATED: { value: 'updated', enumerable: true },
  UPDATE_FAILED: { value: 'update_failed', enumerable: true },
  DELETING: { value: 'deleting', enumerable: true },
  DELETED: { value: 'deleted', enumerable: true },
  DELETE_FAILED: { value: 'delete_failed', enumerable: true },
});

exports.WaNotificationTypes = Object.create(Enum, {
  ACCESS_MGMT: { value: 'accessmgmt', enumerable: true },
});

exports.WaActuatorStatus = Object.create(Enum, {
  OPEN: { value: 'open', enumerable: true },
  CLOSE: { value: 'close', enumerable: true },
  HALF: { value: 'half', enumerable: true },
  VENT: { value: 'vent', enumerable: true },
  OBSTRUCTED: { value: 'obstructed', enumerable: true },
  UNKNOWN: { value: 'unknown', enumerable: true },
});

/**
 * When the Hub report some message to the server
 * This shows the trigger by the cloud or the remtoe
 */
exports.WaMessageTrigger = Object.create(Enum, {
  CLOUD: { value: 'cloud', enumerable: true },
  REMOTE: { value: 'remote', enumerable: true },
});

exports.WaTaskType = Object.create(Enum, {
  HUB: { value: 'hub', enumerable: true },
  ACCESSORY: { value: 'accessory', enumerable: true },
  LOCK: { value: 'lock', enumerable: true },
});

exports.WaTaskPriority = Object.create(Enum, {
  IMPORTANT: { value: Infinity, enumerable: true },
  HIGH: { value: 1000, enumerable: true },
  MEDIUM: { value: 100, enumerable: true },
  LOW: { value: 10, enumerable: true },
  LOWEST: { value: 1, enumerable: true },
});

exports.WaTaskState = Object.create(Enum, {
  CREATED: { value: 'created', enumerable: true },
  SENT: { value: 'sent', enumerable: true },
  SUCCESS: { value: 'success', enumerable: true },
  FAILED: { value: 'failed', enumerable: true },
  TIMEOUT: { value: 'timeout', enumerable: true },
});

exports.WaConnectionStatus = Object.create(Enum, {
  ONLINE: { value: 'online', enumerable: true },
  OFFLINE: { value: 'offline', enumerable: true },
  UNKNOWN: { value: 'unknown', enumerable: true },
});

exports.WaConnectionEvent = Object.create(Enum, {
  CONNECTED: { value: 'connected', enumerable: true },
  DISCONNECTED: { value: 'disconnected', enumerable: true },

  toStatus: {
    value: function(event) {
      if (event === exports.WaConnectionEvent.CONNECTED) {
        return exports.WaConnectionStatus.ONLINE;
      }

      if (event === exports.WaConnectionEvent.DISCONNECTED) {
        return exports.WaConnectionStatus.OFFLINE;
      }

      return exports.WaConnectionStatus.UNKNOWN;
    },
  },
});

exports.WaActionType = Object.create(Enum, {
  SEARCH: { value: 'search', enumerable: true },
  ASSOCIATE: { value: 'associate', enumerable: true },
  ACCEPT: { value: 'accept', enumerable: true },
  REJECT: { value: 'reject', enumerable: true },
  STATUS: { value: 'status', enumerable: true },
  LOG: { value: 'log', enumerable: true },
  OTA: { value: 'ota', enumerable: true },
  REBOOT: { value: 'reboot', enumerable: true },
  RESET: { value: 'reset', enumerable: true },
  PRUNE: { value: 'prune', enumerable: true },
  OPERATE: { value: 'operate', enumerable: true },
  OPEN: { value: 'open', enumerable: true },
  CLOSE: { value: 'close', enumerable: true },
  HALF: { value: 'half', enumerable: true },
  VENT: { value: 'vent', enumerable: true },
  GROUP_OPEN: { value: 'groupOpen', enumerable: true },
  GROUP_CLOSE: { value: 'groupClose', enumerable: true },
  GROUP_HALF: { value: 'groupHalf', enumerable: true },
  GROUP_VENT: { value: 'groupVent', enumerable: true },
  GROUP_CREATE: { value: 'groupCreate', enumerable: true },
  GROUP_DELETE: { value: 'groupDelete', enumerable: true },
  GROUP_ADD: { value: 'groupAdd', enumerable: true },
  GROUP_REMOVE: { value: 'groupRemove', enumerable: true },
  GROUP_LINK: { value: 'groupLink', enumerable: true },
  GROUP_UNLINK: { value: 'groupUnlink', enumerable: true },
  GROUP_SYNC: { value: 'groupSync', enumerable: true },
  BIND: { value: 'bind', enumerable: true },
  UNBIND: { value: 'unbind', enumerable: true },
  DISCONNECT: { value: 'disconnect', enumerable: true },
  CONNECT: { value: 'connect', enumerable: true },
  LOCK: { value: LockActions.LOCK, enumerable: true },
  UNLOCK: { value: LockActions.UNLOCK, enumerable: true },
  UNLATCH: { value: LockActions.UNLATCH, enumerable: true },
  SECURE: { value: LockActions.SECURE, enumerable: true },
  CALIBRATE: { value: LockActions.CALIBRATE, enumerable: true },
  DISABLE_HOMEKIT: { value: LockActions.DISABLE_HOMEKIT, enumerable: true },
  REBOOT_LOCK: { value: LockActions.REBOOT, enumerable: true },
  TELEMETRY: { value: 'telemetry', enumerable: true },
  LOG_COUNT: { value: 'logcount', enumerable: true },
  LOG_V2: { value: 'logV2', enumerable: true },
  CLEAR_ALL_ENTRY_CODES: { value: 'clearAllEntryCodes', enumerable: true },
  SET_PARAMETER: { value: 'setParameter', enumerable: true },
  LOCK_FIRMWARE: { value: 'lockfirmware', enumerable: true },
  SAVE_PIN: { value: 'savePin', enumerable: true },
  UPDATE_PIN: { value: 'updatePin', enumerable: true },
  REMOVE_PIN: { value: 'removePin', enumerable: true },
  SAVE_OFFLINE_KEY: { value: 'saveOfflineKey', enumerable: true },
  REMOVE_OFFLINE_KEY: { value: 'removeOfflineKey', enumerable: true },
  SET_CREDENTIAL_SCHEDULE: { value: 'setCredentialSchedule', enumerable: true },
  REMOVE_CREDENTIAL: { value: 'removeCredential', enumerable: true },
  REMOVE_CREDENTIAL_V2: { value: 'removeCredentialV2', enumerable: true },
  SAVE_CREDENTIAL: { value: 'saveCredential', enumerable: true },
  UPDATE_CREDENTIAL: { value: 'updateCredential', enumerable: true },

  getActionTypesByTaskType: {
    value: function(taskType) {
      if (taskType === exports.WaTaskType.HUB) {
        return [
          this.SEARCH,
          this.ASSOCIATE,
          this.ACCEPT,
          this.REJECT,
          this.STATUS,
          this.GROUP_CREATE,
          this.GROUP_DELETE,
          this.LOG,
          this.OTA,
          this.REBOOT,
          this.RESET,
          this.PRUNE,
          this.CONNECT,
          this.DISCONNECT,
        ];
      } else if (taskType === exports.WaTaskType.ACCESSORY) {
        return [
          this.OPEN,
          this.CLOSE,
          this.HALF,
          this.VENT,
          this.GROUP_OPEN,
          this.GROUP_CLOSE,
          this.GROUP_HALF,
          this.GROUP_VENT,
          this.GROUP_ADD,
          this.GROUP_REMOVE,
          this.STATUS,
          this.REBOOT,
          this.RESET,
        ];
      } else if (taskType === exports.WaTaskType.LOCK) {
        return [
          this.BIND,
          this.UNBIND,
          this.CONNECT,
          this.DISCONNECT,
          this.LOCK,
          this.STATUS,
          this.UNLOCK,
          this.UNLATCH,
          this.SECURE,
          this.CALIBRATE,
          this.DISABLE_HOMEKIT,
          this.REBOOT_LOCK,
          this.TELEMETRY,
          this.LOG_COUNT,
          this.LOG_V2,
          this.CLEAR_ALL_ENTRY,
          this.SET_PARAMETER,
          this.LOCK_FIRMWARE,
          this.SAVE_PIN,
          this.UPDATE_PIN,
          this.REMOVE_PIN,
          this.SAVE_OFFLINE_KEY,
          this.REMOVE_OFFLINE_KEY,
          this.SET_CREDENTIAL_SCHEDULE,
          this.REMOVE_CREDENTIAL,
          this.REMOVE_CREDENTIAL_V2,
          this.SAVE_CREDENTIAL,
          this.UPDATE_CREDENTIAL,
        ];
      }

      return [];
    },
  },
});

exports.WaOperationTargetType = Object.create(Enum, {
  HUB: { value: 'wa_hub', enumerable: true },
  ACTUATOR: { value: 'wa_actuator', enumerable: true },
  GROUP: { value: 'wa_group', enumerable: true },
  REMOTE: { value: 'wa_remote', enumerable: true },
  LOCK: { value: 'lock', enumerable: true },

  changeToTaskType: {
    value: function(targetType) {
      if (targetType === this.HUB) {
        return exports.WaTaskType.HUB;
      } else if (targetType === this.LOCK) {
        return exports.WaTaskType.LOCK;
      }

      return exports.WaTaskType.ACCESSORY;
    },
  },

  toWaType: {
    value: function(rawType) {
      const waType = /^wa_/.test(rawType) ? rawType : `wa_${rawType}`;

      return this.hasValue(waType) ? waType : null;
    },
  },

  toRawType: {
    value: function(waType) {
      return this.hasValue(waType) ? _.replace(waType, 'wa_', '') : null;
    },
  },
});

/**
 * The message type is from the AWS IoT topic:
 * {env}/res/wa/... - Means the response of the MQTT topic
 * {env}/dt/wa/... - Means the data report from the device
 */
exports.WaMessageType = Object.create(Enum, {
  RES: { value: 'res', enumerable: true },
  DATA: { value: 'dt', enumerable: true },
});

exports.WaReportEvent = Object.create(Enum, {
  ACCESSORY_FOUND: { value: 'accessoryFound', enumerable: true },
  ACCESSORY_VALIDATE: { value: 'accessoryValidate', enumerable: true },
  GROUP_ADD: { value: 'groupAdd', enumerable: true },
  GROUP_REMOVE: { value: 'groupRemove', enumerable: true },
  STATUS: { value: 'status', enumerable: true },
  OTA_STATUS: { value: 'otaStatus', enumerable: true },
  ACCESSORY_LEAVE: { value: 'accessoryLeave', enumerable: true },
  LOCK_RESPONSE: { value: 'lockResponse', enumerable: true },
});

exports.WaHubCapabilityType = Object.create(Enum, {
  OMNI: { value: 'omni', enumerable: true },

  getHubCapabilities: {
    value: function(type) {
      if (type === this.OMNI) {
        return { ble: true };
      }

      return {};
    },
  },
});

exports.WaOTAStatus = Object.create(Enum, {
  WAITING: { value: 'waiting', enumerable: true },
  SEND: { value: 'send', enumerable: true },
  UPGRADING: { value: 'upgrading', enumerable: true },
  SUCCESS: { value: 'success', enumerable: true },
  FAILED: { value: 'failed', enumerable: true },
  TIMEOUT: { value: 'timeout', enumerable: true },
  UNKNOWN: { value: 'unknown', enumerable: true },
});

exports.WaActivityFeedActions = Object.create(Enum, {
  SYSTEM_CREATE: { value: 'system_create', enumerable: true },
  SYSTEM_RENAME: { value: 'system_rename', enumerable: true },
  FACTORY_RESET: { value: 'factory_reset', enumerable: true },
  GROUP_CREATE: { value: 'group_create', enumerable: true },
  GROUP_DELETE: { value: 'group_delete', enumerable: true },
  GROUP_SYNC: { value: 'group_sync', enumerable: true },
  GROUP_MEMBER_ADD: { value: 'group_member_add', enumerable: true },
  GROUP_MEMBER_REMOVE: { value: 'group_member_remove', enumerable: true },
  DEVICE_RENAME: { value: 'device_rename', enumerable: true },
  GROUP_RENAME: { value: 'group_rename', enumerable: true },
});

exports.MAX_WA_ACTUATOR_NUMBER_PER_HUB = 30;
exports.MAX_WA_REMOTE_NUMBER_PER_HUB = 4;
exports.MAX_WA_DEVICE_NAME_LENGTH = 40;

exports.WA_HUB_WIFI_KEY_SERIALNUMBER_REDIS_KEY_PREFIX = 'WAHUB:WIFIKEY:SERIALNUMBER';
exports.WA_HUB_PRE_REGISTER_REDIS_KEY_PREFIX = 'WAHUB:PREREGISTER';
